var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2464 6.40197C28.3325 4.53268 25.6683 4.53267 24.7545 6.40198L5.26445 46.2679C4.45248 47.9288 5.6617 49.8659 7.51042 49.8659H46.4904C48.3391 49.8659 49.5484 47.9288 48.7364 46.2679L29.2464 6.40197ZM20.2625 4.20593C23.0042 -1.40196 30.9967 -1.40199 33.7383 4.20592L53.2283 44.0719C55.6642 49.0544 52.0366 54.8659 46.4904 54.8659H7.51042C1.96428 54.8659 -1.66339 49.0544 0.772533 44.0719L20.2625 4.20593Z",
    fill: "#FFB000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5004 18.6159C24.5004 17.2352 25.6197 16.1159 27.0004 16.1159C28.3811 16.1159 29.5004 17.2352 29.5004 18.6159V32.3659C29.5004 33.7466 28.3811 34.8659 27.0004 34.8659C25.6197 34.8659 24.5004 33.7466 24.5004 32.3659V18.6159Z",
    fill: "#FFB000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7505 42.3659C30.7505 44.437 29.0715 46.1159 27.0005 46.1159C24.9294 46.1159 23.2505 44.437 23.2505 42.3659C23.2505 40.2949 24.9294 38.6159 27.0005 38.6159C29.0715 38.6159 30.7505 40.2949 30.7505 42.3659Z",
    fill: "#FFB000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.52e5f4c55a5fa673bd1ecc63a284d1df.svg";
export { ForwardRef as ReactComponent };